var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.cssClasses},[(!_vm.divider && !_vm.header)?_c('a',[_vm._t("default")],2):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }